import { render, staticRenderFns } from "./HelpCenterContentHeader.vue?vue&type=template&id=08654fba&scoped=true&"
var script = {}
import style0 from "./HelpCenterContentHeader.vue?vue&type=style&index=0&id=08654fba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08654fba",
  null
  
)

export default component.exports